import SoloPuzzleInfo from './SoloPuzzleInfo';
export default SoloPuzzleInfo;
